import { render, staticRenderFns } from "./ModalRequisitosDocumentales.vue?vue&type=template&id=210600d1"
import script from "./ModalRequisitosDocumentales.vue?vue&type=script&lang=js"
export * from "./ModalRequisitosDocumentales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports